import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";
class List extends Component {
    state = {
        item: {}
    };

    render() {
        return (
            <Fragment>
                <tr>
				{/*<td>{this.props.item.id}</td>*/}
                    <td>
                        <div className="row align-items-center">
                            <div className="col-auto">
                                <a href="">
                                    <img
                                        src={this.props.item.user.image}
                                        className="cc-image-lg rounded-circle"
                                        alt=""
                                    />
                                </a>
                            </div>
                            <div className="col ml-n2">
                                <h4 className="mb-1 name">
                                    {this.props.item.user.first_name}{" "}
                                    {this.props.item.user.last_name}
                                </h4>
                                <p className="small mb-0">
                                    {this.props.item.user.email}
                                </p>
                            </div>
                        </div>
                    </td>
                    <td>
                        <time dateTime={this.props.item.created_at}>
                            {this.props.item.created_at}
                        </time>
                    </td>
                </tr>
            </Fragment>
        );
    }
}
List.contextType = AppContext;
export default List;



// WEBPACK FOOTER //
// ./src/components/writer/clients/List.js